import React from 'react';

/**
 * DecoDivider - ornamento art-deco compartilhado.
 *
 * variant="chevron" (default): regua horizontal com chevron central, ocupa
 *   100% da largura do container.
 *
 * variant="diamond": ornamento inline com um diamante central entre duas
 *   linhas curtas. Usado dentro de eyebrow/badges.
 *
 * Sempre aria-hidden=true: trata-se de decoracao puramente visual.
 */
const DecoDivider = ({ variant = 'chevron', className = '', style }) => {
  if (variant === 'diamond') {
    return (
      <span
        className={`deco-divider deco-divider--diamond ${className}`}
        style={style}
        aria-hidden="true"
      >
        <svg
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          focusable="false"
        >
          <path d="M3 0L6 3L3 6L0 3L3 0Z" fill="currentColor" opacity="0.7" />
        </svg>
      </span>
    );
  }

  return (
    <div
      className={`deco-divider deco-divider--chevron ${className}`}
      style={style}
      aria-hidden="true"
    >
      <svg
        width="22"
        height="10"
        viewBox="0 0 22 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <path
          d="M2 8L11 2L20 8"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.85"
        />
        <circle cx="11" cy="2" r="1" fill="currentColor" opacity="0.85" />
      </svg>
    </div>
  );
};

export default DecoDivider;
